import {
  Alert,
  AlertTitle,
  Box,
  Collapse,
  TextField,
  Typography,
} from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import Capa from '../../Controls/Capa/Capa'
import EscoSwitch from '../../Controls/EscoSwitch/EscoSwitch'
import { DatePicker } from '@mui/x-date-pickers'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { AuthContext } from '../../../Context/AuthContext'
import EscoAutocomplete from '../../Controls/EscoAutocomplete/EscoAutocomplete'
import Rango from '../../Controls/EscoRango/EscoRango'
import {
  UpdateParam,
  UpdateStateEnviosInterfaces,
} from '../../../Service/microservicioService'
import dayjs from 'dayjs'
import EscoComboBooleano from '../../Controls/EscoComboBooleano/EscoComboBooleano'

function ConfigMicroservicioParamView(props) {
  const { accessToken } = useContext(AuthContext)
  const [detalle, setDetalle] = useState()
  //const [loading, setLoading] = useState(false);
  const [hayCambios, setHayCambios] = useState(false)

  //DIALOG METODOS MSJ ********************
  //Open Close
  const [openMsj, setOpenMsj] = useState(false)
  //Msj Error
  const [msjTitle, setMsjTitle] = useState('')
  const [severityProp, setSeverityProp] = useState('info') // Estado inicial de `severityProp`

  const MsjElement = ({ severityProp }) => {
    return (
      <Collapse in={openMsj}>
        <Alert
          severity={severityProp}
          onClose={() => {
            setOpenMsj(false)
          }}
        >
          {msjTitle}
        </Alert>
      </Collapse>
    )
  }

  //DIALOG METODOS MSJ ********************

  useEffect(() => {
    const { TpValor } = props.dataEdit
    let TpValorActualizar = 'text'

    if (TpValor === 'F') {
      TpValorActualizar = 'date'
    } else if (TpValor === 'N' || TpValor === 'B' || TpValor === 'R') {
      TpValorActualizar = 'number'
    }

    setDetalle({ ...props.dataEdit, TpValorActualizar })
  }, [props.dataEdit])

  const handleChangeBoolean = (e) => {
    setHayCambios(true)

    setDetalle({
      ...detalle,
      Valor:
        detalle.TpValor === 'B'
          ? e.target.checked === true
            ? 'Sí'
            : 'No'
          : e.target.value,
      ValorNumerico:
        detalle.TpValor === 'B'
          ? e.target.checked === true
            ? -1
            : 0
          : e.target.value,
    })
  }

  const handleChangeTexto = (e) => {
    setHayCambios(true)
    setDetalle({
      ...detalle,
      Valor: e.target.value,
      ValorTexto: e.target.value,
    })
  }

  const handleChangeNumerico = (e) => {
    setHayCambios(true)
    const nuevoNumero = e.target.value
    if (!isNaN(nuevoNumero)) {
      setDetalle({
        ...detalle,
        Valor: e.target.value,
        ValorNumerico: e.target.value,
      })
    }
  }

  const handleChangeMultiple = (event, value) => {
    setHayCambios(true)
    setDetalle({
      ...detalle,
      Valor: value.map((item) => item.Descripcion).join('; '), // Concatena descripciones con punto y coma
      ValorTexto: value.map((item) => item.Descripcion).join('; '),
    })
  }

  const handleChangeRango = (valueDsd, valueHst) => {
    setHayCambios(true)
    setDetalle({
      ...detalle,
      Valor: `[${valueDsd};${valueHst}]`,
      ValorNumerico: valueDsd,
      ValorNumericoHst: valueHst,
    })

    //console.log("handleChangeRango", valueDsd, valueHst);
  }

  const handleChangeFecha = (date) => {
    setHayCambios(true)
    setDetalle({
      ...detalle,
      Valor: date.format('MM/DD/YYYY'),
      ValorFecha: date.format('YYYY/MM/DD'),
    })
  }

  const handleComboBooleano = (nuevoValor) => {
    setHayCambios(true)

    setDetalle({
      ...detalle,
      Valor: nuevoValor === -1 ? 'Sí' : nuevoValor === 0 ? 'No' : null,
      ValorNumerico: nuevoValor,
    })
  }

  const handleUpdate = (updateFunction, requestData) => {
    updateFunction({ request: requestData }, accessToken)
      .then((data) => {
        if (data?.Message?.includes('Error')) {
          setMsjTitle(data.Message)
          setOpenMsj(true)
        } else {
          props.pInit()
          props.handleClose()
        }
      })
      .catch((error) => {
        setMsjTitle(error.toString())
        setOpenMsj(true)
      })
  }

  const onAceptar = (e) => {
    e.preventDefault()

    if (hayCambios === false) {
      props.pInit()
      props.handleClose()
      return
    }

    const spUpdateInterfazParamRequest = {
      codServicio: detalle.CodServicio,
      codInterfazServ: detalle.CodInterfazServ,
      codParametroInt: detalle.CodParametroInt,
      valorNumerico: detalle.ValorNumerico,
      valorTexto: detalle.ValorTexto,
      valorFecha: detalle.ValorFecha,
      valorNumericoHst: detalle.ValorNumericoHst,
      valorFechaHst: detalle.valorFechaHst,
    }

    if (detalle.CodParametroInt === 'ENVMANUAL') {
      const spUpdateStateEnviosInterfacesRequest = {
        codServicio: detalle.CodServicio,
        codInterfazServ: detalle.CodInterfazServ,
        activo: detalle.ValorNumerico,
      }

      UpdateStateEnviosInterfaces(accessToken, {
        spUpdateStateEnviosInterfacesRequest,
      })
        .then((data) => {
          if (data?.Message?.includes('Error')) {
            setMsjTitle(data.Message)
            setOpenMsj(true)
            setSeverityProp('error')
          } else {
            setMsjTitle(
              'Actualización exitosa. Se volverá a realizar el envío de datos en la próxima ejecución del servicio según la frecuencia configurada.'
            )
            setOpenMsj(true)
            setSeverityProp('success')
          }
        })
        .catch((error) => {
          setMsjTitle(error.toString())
          setOpenMsj(true)
          setSeverityProp('error')
        })
    } else {
      UpdateParam({ spUpdateInterfazParamRequest }, accessToken)
        .then((data) => {
          if (
            data !== undefined &&
            data.Message !== undefined &&
            data.Message.includes('Error')
          ) {
            setMsjTitle(data.Message)
            setOpenMsj(true)
            return
          } else {
            props.pInit()
            props.handleClose()
          }
        })
        .catch((error) => {
          setMsjTitle(error.toString())
          setOpenMsj(true)
        })
    }
  }

  let componenteRenderizado

  switch (detalle?.TpValor) {
    case 'B':
      componenteRenderizado = (
        <EscoSwitch
          checked={detalle?.Valor === 'Sí' ? true : false}
          onChange={(e) => handleChangeBoolean(e)}
        />
      )
      break
    case 'BM':
      componenteRenderizado = (
        <EscoComboBooleano
          valorInicial={
            detalle?.Valor === 'Sí'
              ? '-1'
              : detalle?.Valor === 'No'
              ? '0'
              : null
          }
          onChange={(e) => handleComboBooleano(e)}
        />
      )
      break
    case 'TX':
      componenteRenderizado = (
        <TextField
          sx={{ width: '100%', p: 1, mt: 1 }}
          multiline
          rows={4}
          id="outlined-basic"
          label="Valor Parámetro"
          variant="outlined"
          name="ValorParametro"
          autoComplete="off"
          onChange={(e) => handleChangeTexto(e)}
          value={detalle?.Valor}
        />
      )
      break
    case 'T': //renderiza TextField
    case 'P': //renderiza TextField
      componenteRenderizado = (
        <TextField
          sx={{ width: '100%', p: 1, mt: 1 }}
          id="outlined-basic"
          label="Valor Parámetro"
          variant="outlined"
          name="ValorParametro"
          autoComplete="off"
          type={detalle?.TpValor === 'P' ? 'password' : null}
          onChange={(e) => handleChangeTexto(e)}
          value={detalle?.Valor}
        />
      )
      break
    case 'F':
      componenteRenderizado = (
        <DatePicker
          label="Valor Parámetro"
          value={dayjs(detalle?.Valor, { format: 'YYYY-MM-DD' })}
          format="DD/MM/YYYY"
          slotProps={{
            textField: {
              helperText: 'DD/MM/YYYY',
            },
          }}
          onChange={handleChangeFecha}
        />
      )
      break
    case 'N':
      componenteRenderizado = (
        <TextField
          label="Valor Parámetro"
          variant="outlined"
          type="number"
          //inputProps={{ step: 'any' }} // Permite números decimales
          value={detalle?.Valor}
          onChange={handleChangeNumerico}
        />
      )
      break
    case 'M':
      componenteRenderizado = (
        <EscoAutocomplete
          name="autocomplete"
          codTpActiveX={detalle?.CodTpActiveX}
          multiple
          onChange={handleChangeMultiple}
          value={detalle?.Valor}
          label="Valor Parámetro"
          placeholder="Valor Parámetro"
        />
      )
      break
    case 'R':
      componenteRenderizado = (
        <Rango
          tipo="numero"
          valorInicial={detalle?.Valor}
          onChange={(desde, hasta) => handleChangeRango(desde, hasta)}
        />
      )
      break
    default:
      componenteRenderizado = <p>Componente por defecto</p>
  }

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box
          component={'form'}
          onSubmit={onAceptar} /*onSubmit={props.onAceptar}*/
        >
          <Capa onCancel={props.handleClose} title={'Parámetro'}>
            <Typography
              variant="button"
              sx={{ fontSize: 14, color: 'gray', mb: 1 }}
            >
              {detalle?.Descripcion}
            </Typography>
            <Alert severity="info" sx={{ mb: 1 }}>
              <AlertTitle>Funcionalidad</AlertTitle>
              {detalle?.Observaciones}
            </Alert>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                mb: 1,
                mt: 1,
              }}
            >
              {componenteRenderizado}
            </Box>
            <MsjElement severityProp={severityProp} />
          </Capa>
        </Box>
      </LocalizationProvider>
    </>
  )
}

export default ConfigMicroservicioParamView
